import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
}

export const ActionBlockModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
}) => {
  const navigate = useNavigate();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate("/app/solicitudes");
  }, [onClose, navigate]);

  const handleRealizarTransferencia = useCallback(() => {
    onClose();
    navigate("/app/registro/firma-electronica-avanzada/transferencia-bancaria");
  }, [onClose, navigate]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Probar otro método",
        onClick: handleRealizarTransferencia,
      }}
    />
  );
};
